export default {"src":"/trader-new/_next/static/media/BankAccountDetails.9d507d60.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};